import GrowthDiscoveryEpicClient from 'bundles/epic/clients/GrowthDiscovery';

const isComposablePageHeaderEnabledOnXDP = (preview: boolean = false) => {
  if (preview) {
    return GrowthDiscoveryEpicClient.preview('enableComposablePageHeaderOnXDP');
  } else {
    return GrowthDiscoveryEpicClient.get('enableComposablePageHeaderOnXDP');
  }
};

export default isComposablePageHeaderEnabledOnXDP;
